import { Children, isValidElement, cloneElement, forwardRef } from 'react';
import classNames from 'classnames';
import css from './ButtonGroup.module.scss';
/** Use when you have multiple buttons to space them out evenly. */
const ButtonGroup = forwardRef((props, ref) => {
    const { children, className, fullWidth = false, role = 'group', connected = false, size, vertical = false, ...other } = props;
    // classes applied to cloned Button children
    const btnGroupClasses = classNames(css.childBtn, {
        [css.groupedHorizontalBtn]: !connected && !vertical,
        [css.groupedVerticalBtn]: !connected && vertical,
        [css.connectedHorizontalBtn]: connected && !vertical,
        [css.connectedVerticalBtn]: connected && vertical
    });
    return (<div ref={ref} role={role} className={classNames(css.btnGroup, {
        [css.verticalGroup]: vertical
    }, className)} {...other}>
        {Children.map(children, (child) => {
        if (!isValidElement(child)) {
            return null;
        }
        return cloneElement(child, {
            ...child.props,
            className: classNames(btnGroupClasses, child.props.className),
            size: child.props.size || size,
            fullWidth
        });
    })}
      </div>);
});
ButtonGroup.displayName = 'ButtonGroup';
export { ButtonGroup };
//# sourceMappingURL=ButtonGroup.jsx.map